// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ILandSchema {
  /** Площадь участка **/
  area?: number;
  /** Единица измерения **/
  areaUnitType?: EAreaUnitType;
  /** Возможно изменить cтатус **/
  possibleToChangeStatus?: boolean;
  /** Статус **/
  status?: EStatus;
  /** Тип участка **/
  type?: EType;
}
export enum EAreaUnitType {
  /** Гектар **/
  'Hectare' = 'hectare',
  /** Сотка **/
  'Sotka' = 'sotka',
}
export enum EStatus {
  /** Фермерское хозяйство **/
  'Farm' = 'farm',
  /** Участок сельскохозяйственного назначения **/
  'ForAgriculturalPurposes' = 'forAgriculturalPurposes',
  /** Участок лесного фонда **/
  'ForestArea' = 'forestArea',
  /** Садоводство **/
  'Gardening' = 'gardening',
  /** Садовое некоммерческое товарищество **/
  'GardeningNonProfitPartnership' = 'gardeningNonProfitPartnership',
  /** Индивидуальное жилищное строительство **/
  'IndividualHousingConstruction' = 'individualHousingConstruction',
  /** Земля промышленного назначения **/
  'IndustrialLand' = 'industrialLand',
  /** Участок промышленности, транспорта, связи и иного не сельхоз. назначения **/
  'IndustryTransportCommunications' = 'industryTransportCommunications',
  /** Инвестпроект **/
  'InvestmentProject' = 'investmentProject',
  /** Особо охраняемых категорий **/
  'OfProtectedCategories' = 'ofProtectedCategories',
  /** Личное подсобное хозяйство **/
  'PrivateFarm' = 'privateFarm',
  /** Участок запаса **/
  'Reserve' = 'reserve',
  /** Участок поселений **/
  'Settlements' = 'settlements',
  /** Дачное некоммерческое партнерство **/
  'SuburbanNonProfitPartnership' = 'suburbanNonProfitPartnership',
  /** Дачное некоммерческое партнерство поселений **/
  'SuburbanNonProfitSettlementsPartnership' = 'suburbanNonProfitSettlementsPartnership',
  /** Участок водного фонда **/
  'WaterArea' = 'waterArea',
}
export enum EType {
  /** В собственности **/
  'Owned' = 'owned',
  /** В аренде **/
  'Rent' = 'rent',
}
